import { ConfigurationOntologyForAutomaticAssayResponse } from '@/modules/configurationModule/detail/automation/assays/services/configuration-ontology-for-automatic-assay/configuration-ontology-for-automatic-assay.dto'
import { store } from '@/store/store'

export interface ConfigurationAutomationAssaysModalBasicFormState {
    ontologyForAutomaticAssay: Partial<ConfigurationOntologyForAutomaticAssayResponse>
    laboratoryId: number
}
export const initialConfigurationAutomationAssaysModalBasicFormState =
    (): ConfigurationAutomationAssaysModalBasicFormState => ({
        ontologyForAutomaticAssay: {},
        laboratoryId: store.getters.labId
    })
